import { FC } from 'react';
import { IconCardGridT } from '@components/Organisms/IconCardGrid/types';
import { IconCard } from '@components/Organisms/IconCardGrid/IconCard';
import { StyledIconCardGrid } from '@components/Organisms/IconCardGrid/styled/StyledIconCardGrid';

export const IconCardGrid: FC<IconCardGridT> = ({ title, display, iconCards }) => {
  if (!display) return null;

  return (
    <StyledIconCardGrid className="pt-8 pb-12">
      <h2>{title}</h2>
      {!!iconCards?.length && (
        <div className="px-6 py-12 mx-4 md:mx-auto md:container md:px-8 lg:px-32">
          <div className="grid">
            {iconCards?.map((iconCard, index) => (
              <IconCard
                key={`${index}-IconCard`}
                heading={iconCard.heading}
                body={iconCard.body}
                icon={iconCard.icon}
                display={iconCard.display}
              />
            ))}
          </div>
        </div>
      )}
    </StyledIconCardGrid>
  );
};
